import { translation } from './translation'

export const dict = {
  language: translation.language,
  role: translation.role,
  status: translation.status,
}
